/**
 * Exporta um array de objetos para um arquivo CSV.
 * @param {string} filename - O nome do arquivo a ser baixado (ex: 'dados.csv').
 * @param {Array<Object>} columns - Um array de objetos definindo as colunas.
 * Cada objeto deve ter: { text: 'Cabeçalho', value: 'chaveNoObjeto', formatter?: (value, row) => 'valorFormatado' }
 * @param {Array<Object>} data - O array de dados a ser exportado.
 */
export function exportToCsv(filename, columns, data) {
    if (!data || data.length === 0) {
      console.warn('Nenhum dado para exportar.')
      return
    }
    const headers = columns.map(col => `"${col.text}"`).join(',')
    const rows = data.map(row => {
      return columns.map(col => {
        let value = row[col.value]
        if (col.formatter && typeof col.formatter === 'function') {
          value = col.formatter(value, row)
        }
        const stringValue = String(value ?? '') 
        return `"${stringValue.replace(/"/g, '""')}"`
      }).join(',')
    }).join('\n')
    const csvContent = `${headers}\n${rows}`
    const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
  
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }